'use strict';

const CardUI = require('grpn-card-ui/frontend/init');

const recommendedForYouSelector = 'section.recommended-for-you';

function removeRecommendedForYou() {
  return $(recommendedForYouSelector).remove();
}

function fetchMegamindAndRender() {
  const merchantSlug = (window.location.pathname.match(/\/biz\/(.+)/) || [])[1];

  if (!merchantSlug) {
    removeRecommendedForYou();
    return;
  }

  const place = $('.mpp-container').data();
  const data = {
    lat: place.placeLat,
    lon: place.placeLon,
    division: place.placeDivision,
  };
  const request = $.get(
    `/merchant-page/megamind/${merchantSlug}`,
    data,
    res => {
      let $recommendedForYouDealsList;

      if (res && res.data && res.data.cardatronCards) {
        $recommendedForYouDealsList = $(`${recommendedForYouSelector}`);
        $recommendedForYouDealsList.addClass('cui-four-up');
        $recommendedForYouDealsList.html(res.data.cardatronCards);
        CardUI.init($recommendedForYouDealsList);
        window.GIG.Utils.truncateElements(recommendedForYouSelector);
      } else {
        removeRecommendedForYou();
      }
    }
  );
  request.fail(() => removeRecommendedForYou());
}

$(() => {
  if (!$(recommendedForYouSelector).length) {
    return;
  }

  fetchMegamindAndRender();
});
